import PassportRequirementSubmissionsHealthcare from "./PassportRequirementSubmissionsHealthcare";

export default PassportRequirementSubmissionsHealthcare;